import React from "react";
import { useState, useContext } from "react";
import "./LogInPage.css";
import image from "../pictures/BudgetMasterLogo.png";
import SignIn from "../Authentication/SignIn";
import SignUp from "../Authentication/SignUp";
import Reset from "../Authentication/Reset";
import AuthContext from "../store/auth-context";

function LogInPage(props) {
  const [loggin, setLoggIn] = useState(false);
  const [signup, setSignUp] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);
  const authCtx = useContext(AuthContext);

  function signInHandler() {
    setLoggIn(true);
  }
  function signUpHandler() {
    setSignUp(true);
  }

  function takeMeToSignUp() {
    setForgotPassword(false);
    setLoggIn(false);
    setSignUp(true);
  }

  function takeMeToSignIn() {
    setForgotPassword(false);
    setLoggIn(true);
    setSignUp(false);
  }

  function takeMeToResetPassword() {
    setLoggIn(false);
    setSignUp(false);
    setForgotPassword(true);
  }
  return (
    <>
      <div className="container-fluid loginPage">
        {authCtx.justSignedUp && (
          <div class="alert alert-warning al" role="alert">
            Please Verify Your Email To Login (Check Junk)!
          </div>
        )}
        {authCtx.errorMessage && (
          <div class="alert alert-warning al" role="alert">
            {authCtx.errorMessage}
          </div>
        )}

        <div className="row">
          <div className="col-xl-10"></div>
          <div className="col-xl-2 text-center myName">
            <a
              href="https://www.linkedin.com/in/ramy-attalla/"
              className="myName"
            >
              Developed By Ramy Attalla
            </a>
          </div>
        </div>
        <div className="row height">
          <div className="col-xl-2"></div>
          <div className="col-xl-8 height text-center">
            <div className="titles">
              <h1 className="title">Budget Master</h1>
              {loggin == false && signup == false && forgotPassword == false && (
                <>
                  <h1 className="subTitle">Manage Your Finances Now!</h1>
                  <button
                    type="button"
                    onClick={signInHandler}
                    class="btn btn-primary signInButton"
                  >
                    Log-In!
                  </button>
                  <button
                    type="button"
                    onClick={signUpHandler}
                    class="btn btn-primary signUpButton"
                  >
                    Sign-Up!
                  </button>
                </>
              )}
              {loggin && (
                <SignIn
                  takeMeToSignUp={takeMeToSignUp}
                  takeMeToResetPassword={takeMeToResetPassword}
                ></SignIn>
              )}
              {signup && <SignUp takeMeToSignIn={takeMeToSignIn}></SignUp>}
              {forgotPassword == true && (
                <Reset signIn={takeMeToSignIn} signUp={takeMeToSignUp}></Reset>
              )}
            </div>
          </div>
          <div className="col-xl-2"></div>
        </div>
        <br></br>
        <div className="row">
          <div className="col-xl-7 bgColor"></div>
          <div className="col-xl-5 text-center bgColor">
            {!loggin && !signup && !forgotPassword && (
              <img src={image} className="image"></img>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
export default LogInPage;
